function disableNavHover() {
  if (!document.body.classList.contains("nav-cooldown")) {
    document.body.classList.add('nav-cooldown');
  }
}
//disableNavHover();

function enableNavHover(instant = false) {
  if (instant) {
    document.body.classList.remove('nav-cooldown');
  } else {
    setTimeout(function() {
      document.body.classList.remove('nav-cooldown');
    }, 2000);
  }
}


function onHoverJoiiMenuElements(section = document) {
    let onHoverDesktopSearchResults = document.querySelector('#joiiDesktopSearchResults .joii-predictive-search');
    var onHoverDesktopMenus = document.querySelectorAll('.header-categories-wrapper.nav-submenu');
    let onHoverNavElements = document.querySelectorAll(
        ".joii-custom-details-disclosure"
    );
  
    // onHoverDesktopSearchResults.addEventListener("mouseover", () => {
    //   enableNavHover(true);
    // });
    // if (onHoverDesktopSearchResults && desktopMenu) {
    //     onHoverDesktopSearchResults.addEventListener("mouseleave", () => {
    //     hideThisMenu(desktopMenu.closest('.joii-custom-details-disclosure'));
    //     });
    // }
    let onHoverMenuCategories = document.querySelectorAll(
        ".joii-categories-menu"
    );
    onHoverDesktopMenus.forEach(function(desktopMenu) {
    //   desktopMenu.addEventListener("mouseover", () => {
    //     enableNavHover(true);
    //   });
      desktopMenu.addEventListener("mouseleave", () => {
        //enableNavHover(true);
        var det_disc = desktopMenu.closest('.joii-custom-details-disclosure') || false;
        if (det_disc) {
            hideThisMenu(det_disc);
            det_disc.classList.remove('open');
        }
      });
    });
    Array.from(onHoverMenuCategories).forEach(function(menuElement) {
        menuElement.addEventListener("mouseover", () => {
            Array.from(
                document.querySelectorAll(".categories-inner--submenu")
            ).forEach(function(element) {
                if (menuElement.classList.contains("sub-category-menu")) {
                    let index = menuElement.dataset.index;
                    let contentElement = document.querySelector(
                        ".sub-category-menu-content-" + index
                    );
                    if (contentElement == element) {
                        element.classList.remove("hidden");
                    } else {
                        element.classList.add("hidden");
                    }
                } else {
                    element.classList.add("hidden");
                }
            });
        });
    });
    let onHoverMenuItems = document.querySelectorAll(
        ".joii-categories-submenu-item"
    );
    Array.from(onHoverMenuItems).forEach(function(menuElement) {
        menuElement.addEventListener("mouseover", () => {
            Array.from(
                document.querySelectorAll(".categories-inner--submenu")
            ).forEach(function(element) {
                if (menuElement.classList.contains("sub-category-menu")) {
                    let index = menuElement.dataset.index;
                    let contentElement = document.querySelector(
                        ".sub-category-menu-content-" + index
                    );
                    if (contentElement == element) {
                        element.classList.remove("hidden");
                        menuElement.classList.remove("isHidden");
                    } else {
                        element.classList.add("hidden");
                        menuElement.classList.add("isHidden");
                    }
                } else {
                    element.classList.add("hidden");
                    menuElement.classList.add("isHidden");
                }
            });
        });
    });

    function hideThisMenu(menuBlock) {
      //if (!document.body.classList.contains("nav-cooldown")) {
        Array.from(
          document.querySelectorAll(".joii-custom-details-disclosure")
        ).forEach(function(element) {
            element.removeAttribute("open");
            element.classList.remove("open");
            Array.from(
                element.querySelectorAll(".sub-menu-custom-details-disclosure")
            ).forEach(function(childElement) {
                childElement.removeAttribute("open");
            });
        });
    //   } else {
    //     setTimeout(function() {
    //       hideThisMenu(menuBlock);
    //     }, 1000);
    //   }
    }
    Array.from(onHoverNavElements).forEach(function(navElement) {

        navElement.addEventListener("mouseover", () => {
            // let delay = 0.1;
            if (navElement.classList.contains('open')) return false;
            if (navElement.parentElement.classList.contains("has-children")) {
                document.querySelector("body").classList.add("megamenu-open");
                // let childelements = navElement.querySelectorAll(".joii-custom-details-disclosure.open .nav-submenu li");
                // Array.from(childelements).forEach(function(childelement){
                //   childelement.style.transitionDelay  = delay +'s';
                //     delay=delay+0.1;
                // })
            }
            Array.from(
                document.querySelectorAll("[data-search-input]")
            ).forEach(function(element) {
                element.value = '';
            });
            Array.from(
                document.querySelectorAll("[data-result-container]")
            ).forEach(function(element) {
                element.classList.add('hidden');
            });
            Array.from(
                document.querySelectorAll("[data-search-drawer]")
            ).forEach(function(element) {
                element.classList.add('hidden');
                element.classList.remove('active');
            });
            document.querySelector('body').classList.remove('search-drawer-open', 'no-scroll');

            Array.from(
                document.querySelectorAll(".category-custom-details-disclosure")
            ).forEach(function(element) {
                if (element.hasAttribute("open")) {
                    element.classList.remove("open");
                    element.removeAttribute("open");
                    document.querySelector("body").classList.remove("megamenu-open");
                }
            });

            Array.from(
                document.querySelectorAll(".joii-custom-details-disclosure")
            ).forEach(function(element) {
                if (navElement == element) {
                    navElement.setAttribute("open", '');
                    navElement.classList.add("open");
                    navElement.closest(".header-nav-blocks").classList.add("megamenu-block");
                } else {
                    element.removeAttribute("open");
                    element.classList.remove("open");
                    Array.from(
                        element.querySelectorAll(".sub-menu-custom-details-disclosure")
                    ).forEach(function(childElement) {
                        childElement.removeAttribute("open");
                    });
                }
            });
            // disableNavHover();
        });

        navElement.addEventListener("mouseleave", () => {
            if (document.body.classList.contains("nav-cooldown")) {
              //enableNavHover();
            } else {
              //navElement.classList.remove("open");
              //navElement.removeAttribute("open");
              //document.querySelector("body").classList.remove("megamenu-open");
            }
            // let childelements = navElement.querySelectorAll(".nav-submenu li");
            //   Array.from(childelements).forEach(function(childelement){
            //     childelement.style.transitionDelay  = 'unset';

            //   })
        });
    });
    let onHoverSubMenuElements = document.querySelectorAll(
        ".sub-menu-custom-details-disclosure"
    );
    Array.from(onHoverSubMenuElements).forEach(function(subMenuElement) {
        subMenuElement.addEventListener("mouseover", () => {
            Array.from(
                document.querySelectorAll(".sub-menu-custom-details-disclosure")
            ).forEach(function(element) {
                if (subMenuElement == element) {
                    element.setAttribute("open", "");
                } else {
                    element.removeAttribute("open");
                }
            });
        });
    });
    let categoriesSelectors = document.querySelectorAll(
        ".category-custom-details-disclosure"
    );
    Array.from(categoriesSelectors).forEach(function(categoriesSelector) {
        categoriesSelector.addEventListener("click", () => {
            setTimeout(function() {
                if (categoriesSelector.hasAttribute("open")) {

                    Array.from(
                        document.querySelectorAll("[data-search-input]")
                    ).forEach(function(element) {
                        element.value = '';
                    });
                    Array.from(
                        document.querySelectorAll("[data-result-container]")
                    ).forEach(function(element) {
                        element.classList.add('hidden');
                    });
                    Array.from(
                        document.querySelectorAll("[data-search-drawer]")
                    ).forEach(function(element) {
                        element.classList.add('hidden');
                        element.classList.remove('active');
                    });
                    document.querySelector('body').classList.remove('search-drawer-open', 'no-scroll');
                    document.querySelector("body").classList.add("megamenu-open");
                } else {
                    document.querySelector("body").classList.remove("megamenu-open");
                }
            }, 100);
        });
    });
}

var mouse_is_inside = false;

function joiiOutSideClickTrigger() {
    let elementList = document.querySelectorAll(
        "[data-humburger-body],[data-hamburger-menu], #joiiDesktopSearchResults, .joiiDesktopSearchInput, .compare-modal-content,[data-button-compare],[data-quick-view],.side-drawer-content,.product-menus-list-item,[data-side-drawer-open],.sr-product-model-item,.header-top-wrap,.header-search,.joii-search-content,[data-search-open],.header-categories-wrapper,.category-custom-details-disclosure,.joii-custom-details-disclosure,.sub-menu-custom-details-disclosure, .announcement-dropdown,.popup-content-inner,[data-cart-drwaer-body]"
    );
    Array.from(elementList).forEach(function(element) {
        element.addEventListener("mouseover", () => {
            mouse_is_inside = true;
        });

        element.addEventListener("mouseout", () => {
            mouse_is_inside = false;
        });
    });

    document.addEventListener("click", function() {
        if (!mouse_is_inside) {
            document.querySelector("body").classList.remove("no-scroll");
            document.querySelector("body").classList.remove("popup-open");
            let searchDrawer = document.querySelector("[data-search-drawer]");
            if (searchDrawer && searchDrawer.classList.contains('joiiMobileSearch')) {
                let headerStyle = searchDrawer.getAttribute("data-header");
                let resultContainer = searchDrawer.querySelector(
                    "[data-result-container]"
                );
                let suggestionContainer = searchDrawer.querySelector(
                    "[data-suggestions-container]"
                );
                if (suggestionContainer) {
                    suggestionContainer.classList.remove("hidden");
                }
                searchDrawer.classList.add("hidden");
                searchDrawer.classList.remove("active");
                document.querySelector("body").classList.remove("search-drawer-open");
                if (resultContainer) {
                    resultContainer.classList.add("hidden");
                }
                if (
                    headerStyle == "logo_with_search_bar" &&
                    document.querySelector("[data-search-input]")
                ) {
                    document.querySelector("[data-search-input]").value = "";
                }
            }
            let announcementActive = document.querySelector(
                ".announcement-btn.active"
            );
            if (announcementActive) {
                announcementActive.click();
            }
            Array.from(
                document.querySelectorAll(".categories-inner--submenu")
            ).forEach(function(element) {
                element.classList.add("hidden");
            });
            Array.from(
                document.querySelectorAll(".category-custom-details-disclosure")
            ).forEach(function(element) {
                element.removeAttribute("open");
                document.querySelector("body").classList.remove("megamenu-open");
            });
        }
    });

    document.addEventListener("keyup", function(event) {
        if (event.keyCode == 27) {
            let searchDrawer = document.querySelector("[data-search-drawer]");
            if (searchDrawer) {
                let headerStyle = searchDrawer.getAttribute("data-header");
                let resultContainer = searchDrawer.querySelector(
                    "[data-result-container]"
                );
                let suggestionContainer = searchDrawer.querySelector(
                    "[data-suggestions-container]"
                );
                if (suggestionContainer) {
                    suggestionContainer.classList.remove("hidden");
                }
                searchDrawer.classList.add("hidden");
                searchDrawer.classList.remove("active");
                if (resultContainer) {
                    resultContainer.classList.add("hidden");
                }
                if (
                    headerStyle == "logo_with_search_bar" &&
                    document.querySelector("[data-search-input]")
                ) {
                    document.querySelector("[data-search-input]").value = "";
                }
            }
            document.querySelector("body").classList.remove("no-scroll");
            let announcementActive = document.querySelector(
                ".announcement-btn.active"
            );
            if (announcementActive) {
                announcementActive.click();
            }
            Array.from(
                document.querySelectorAll(".categories-inner--submenu")
            ).forEach(function(element) {
                element.classList.add("hidden");
            });
            Array.from(
                document.querySelectorAll(".category-custom-details-disclosure")
            ).forEach(function(element) {
                element.removeAttribute("open");
                document.querySelector("body").classList.remove("megamenu-open");
            });
            let sideDraweropenElements =
                document.querySelectorAll("[data-side-drawer]");
            Array.from(sideDraweropenElements).forEach(function(sideDrawer) {
                if (sideDrawer.classList.contains("collection-filter-sidebar"))
                    return false;
                setTimeout(function() {
                    sideDrawer.style.display = "none";
                }, 300);
                sideDrawer.classList.remove("sidebar-visible", "popup-visible");
                document.querySelector("body").classList.remove("no-scroll");
                stopFocusRotation();
                if (previousFocusElement) {
                    if (previousFocusElement.classList.contains("product-quickview")) {
                        if (
                            previousFocusElement
                            .closest("[data-product-grid]")
                            .querySelector(".product-title")
                        ) {
                            previousFocusElement
                                .closest("[data-product-grid]")
                                .dispatchEvent(new Event("mouseover"));
                            previousFocusElement
                                .closest("[data-product-grid]")
                                .querySelector(".product-title")
                                .focus();
                        }
                    } else {
                        previousFocusElement.focus();
                    }
                }
                previousFocusElement = "";
                if (sideDrawer.classList.contains("address-sidebar")) {
                    let addressForm = sideDrawer.querySelector("form");
                    if (addressForm) {
                        addressForm.reset();
                    }
                }
            });
        }
    });

    document.addEventListener("mouseover", function() {
        if (!mouse_is_inside) {
            Array.from(
                document.querySelectorAll(".categories-inner--submenu")
            ).forEach(function(element) {
                element.classList.add("hidden");
            });
            Array.from(
                document.querySelectorAll(".joii-custom-details-disclosure")
            ).forEach(function(element) {
                element.removeAttribute("open");
                element.classList.remove("open");
                element
                    .closest(".header-nav-blocks")
                    .classList.remove("megamenu-block");
            });
            Array.from(
                document.querySelectorAll(".sub-menu-custom-details-disclosure")
            ).forEach(function(element) {
                element.removeAttribute("open");
            });
        }
    });
}


document.addEventListener("DOMContentLoaded", function() {
  //joiiOutSideClickTrigger();
  onHoverJoiiMenuElements();
});
document.addEventListener("shopify:section:load", function(event) {
  let _section = event.target;
  search_drawer(_section);
});

/* ---------------------------------------------------------------------------
   Wishlist heart animations (Oct 2026)
   Fish Wishlist buttons: .joii-product-card-wish (product cards) and
   .joii-wishlist-btn-prod-page (product page). Kept here, self-contained,
   because this file loads on every page.
   - hover: a quick double heartbeat (cards also lift onto a solid white disc)
   - adding: the filled heart pops in with a ring rippling out
   - removing: a small dip
   The app re-checks every heart's saved state after the page loads, so the
   pop only plays when that heart was clicked in the last few seconds; hearts
   that were already saved never pop on page load.
   Respects prefers-reduced-motion.

   Scroll fix: after an add, the app opens its "My wishlists" drawer and locks
   page scroll (body.overflow-hidden, html.lock) until the drawer closes. The
   theme hides that drawer (joii-custom.css: wishlists-drawer display none), so
   it could never be closed and scrolling stayed stuck. Any wishlist drawer that
   opens while hidden is now closed straight away, which releases the lock.
--------------------------------------------------------------------------- */
(function () {
  if (window.joiiWishAnim) return;
  window.joiiWishAnim = true;

  var css = [
    '@keyframes joii-heartbeat { 0%{transform:scale(1)} 14%{transform:scale(1.22)} 28%{transform:scale(1)} 42%{transform:scale(1.14)} 70%{transform:scale(1)} }',
    '@keyframes joii-heart-pop { 0%{transform:scale(.3)} 45%{transform:scale(1.35)} 70%{transform:scale(.9)} 100%{transform:scale(1)} }',
    '@keyframes joii-heart-ring { 0%{transform:scale(.5);opacity:.8} 100%{transform:scale(1.8);opacity:0} }',
    '@keyframes joii-heart-drop { 0%{transform:scale(1)} 40%{transform:scale(.7)} 100%{transform:scale(1)} }',
    '.joii-product-card-wish, .joii-wishlist-btn-prod-page { transition: background-color .2s ease, box-shadow .2s ease; }',
    '.joii-wishlist-btn-prod-page { position: relative; }',
    '.joii-product-card-wish svg, .joii-wishlist-btn-prod-page svg { transform-origin: center; }',
    '@media (hover: hover) {',
    '  .joii-product-card-wish:hover { background: #fff; box-shadow: 0 4px 12px rgba(52, 77, 128, .2); }',
    '  .joii-product-card-wish:hover svg, .joii-wishlist-btn-prod-page:hover svg { animation: joii-heartbeat 1s ease-in-out; }',
    '}',
    '.joii-wish-pop .added-state svg { animation: joii-heart-pop .5s cubic-bezier(.2, .8, .3, 1.2) !important; }',
    '.joii-wish-pop::after { content: ""; position: absolute; inset: 0; border-radius: inherit; border: 2px solid #4272a6; pointer-events: none; animation: joii-heart-ring .55s ease-out forwards; }',
    '.joii-wish-drop .empty-state svg { animation: joii-heart-drop .35s ease !important; }',
    '@media (prefers-reduced-motion: reduce) {',
    '  .joii-product-card-wish svg, .joii-wishlist-btn-prod-page svg, .joii-wish-pop::after { animation: none !important; }',
    '}'
  ].join('\n');

  function addStyle() {
    if (document.getElementById('joii-wish-anim-css')) return;
    var style = document.createElement('style');
    style.id = 'joii-wish-anim-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // remember which heart was just clicked
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('wishlist-button-pdp');
    if (btn) btn.joiiWishClicked = Date.now();
  }, true);

  function watch() {
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var el = m.target;
        if (!el.matches || !el.matches('wishlist-button-pdp')) return;
        if (!el.joiiWishClicked || Date.now() - el.joiiWishClicked > 5000) return;
        var now = el.getAttribute('data-is-added');
        if (now === m.oldValue) return;
        var cls = now === 'true' ? 'joii-wish-pop' : 'joii-wish-drop';
        el.classList.remove('joii-wish-pop', 'joii-wish-drop');
        void el.offsetWidth; // restart the animation if clicked again quickly
        el.classList.add(cls);
        clearTimeout(el.joiiWishTimer);
        el.joiiWishTimer = setTimeout(function () { el.classList.remove(cls); }, 650);
      });
    }).observe(document.body, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['data-is-added'] });
  }

  // close any wishlist drawer that opens while the theme has it hidden, so it can't lock scrolling
  function unlockHiddenDrawers() {
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var el = m.target;
        if (!el.matches || !el.matches('wishlists-drawer, atw-drawer')) return;
        if (el.getAttribute('data-open') !== 'true') return;
        if (getComputedStyle(el).display !== 'none') return;
        if (typeof el.close === 'function') {
          el.close();
        } else {
          el.setAttribute('data-open', 'false');
          document.body.classList.remove('overflow-hidden');
          document.documentElement.classList.remove('lock');
        }
      });
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['data-open'] });
  }

  addStyle();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); unlockHiddenDrawers(); });
  } else {
    watch();
    unlockHiddenDrawers();
  }
})();

/* ---------------------------------------------------------------------------
   Mega menu brand logos: preload before they're seen (Oct 2026)
   The Dogs / Cats panels each show their own featured_brands logos
   (.categories-inner-submenu-brands img, loading="lazy"). Lazy images inside a
   hidden panel only start downloading when the panel opens, so they popped in.
   Two triggers, whichever comes first:
   - intent: hovering, focusing or tapping the header nav / mobile menu button
   - idle: on desktop (mouse + 1025px+), once the page has loaded and the
     browser is idle. Phones only fetch them when the menu is opened.
   Switching the images to eager makes the browser fetch them straight away;
   repeated logos across panels share one URL, so each is downloaded once.
--------------------------------------------------------------------------- */
(function () {
  if (window.joiiBrandPreload) return;
  window.joiiBrandPreload = true;
  var done = false;

  function preloadBrandLogos() {
    if (done) return;
    done = true;
    document.querySelectorAll('.categories-inner-submenu-brands img').forEach(function (img) {
      if (img.loading === 'lazy') img.loading = 'eager';
    });
  }

  function onIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.header-nav-blocks, .header-categories, [data-mobile-menu], .mobileMenu, #mobileMenu')) {
      preloadBrandLogos();
      ['pointerover', 'focusin', 'touchstart'].forEach(function (type) {
        document.removeEventListener(type, onIntent, true);
      });
    }
  }
  ['pointerover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, onIntent, { capture: true, passive: true });
  });

  function idlePreload() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 1025px)').matches) return;
    var go = function () { preloadBrandLogos(); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(go, { timeout: 4000 });
    } else {
      setTimeout(go, 2000);
    }
  }
  if (document.readyState === 'complete') {
    idlePreload();
  } else {
    window.addEventListener('load', idlePreload);
  }
})();
